<mat-horizontal-stepper
  #stepper
  linear
  class="custom-stepper job-stepper"
  [selectedIndex]="initialStepIndex"
>
  <ng-template
    matStepperIcon="edit"
    let-index="index"
  > {{index + 1}} </ng-template>
  <ng-template
    matStepperIcon="create"
    let-index="index"
  > {{index + 1}} </ng-template>
  <mat-step
    label="Basic info"
    [stepControl]="basicForm"
    [completed]="false"
  >
    <mojo-jobs-form-basic
      class="job-form-step-container"
      [form]="basicForm"
      [job]="job"
      [isEdit]="editMode"
      [isRequired]="isRequired"
    >
    </mojo-jobs-form-basic>

    <div class="text-center buttons">
      <button
        mat-raised-button
        color="primary"
        [disabled]="disabled"
        matStepperNext
        class="lg"
        (click)="validate(basicForm)"
        data-cy="job-form-basic-next-button"
      >
        NEXT
      </button>
    </div>
  </mat-step>

  <mat-step
    label="Job description"
    [stepControl]="descriptionForm"
    [completed]="false"
  >
    <mojo-jobs-form-description
      class="job-form-step-container"
      [form]="descriptionForm"
      [job]="job"
    >
    </mojo-jobs-form-description>
    <div class="text-center buttons">
      <button
        mat-raised-button
        color="primary"
        matStepperNext
        *ngIf="!editMode"
        class="lg"
        (click)="validate(descriptionForm)"
        data-cy="job-form-description-next-button"
      >
        NEXT
      </button>
      <button
        mat-raised-button
        color="primary"
        *ngIf="editMode"
        [disabled]="!descriptionForm.valid"
        class="lg"
        (click)="submit()"
      >
        SAVE
      </button>
    </div>
  </mat-step>

  <!-- Show only for creation flow - MOJAT-2122 -->
  <ng-container *ngIf="!editMode">
    <mat-step
      label="Job status"
      *ngIf="user$ | async"
      [stepControl]="statusForm"
      [completed]="false"
    >

      <mojo-jobs-form-status
        class="job-form-step-container"
        [form]="statusForm"
      ></mojo-jobs-form-status>

      <div class="text-center buttons">
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          class="lg"
          [disabled]="!statusForm.valid"
          data-cy="job-form-status-next-button"
        >
          NEXT
        </button>
      </div>
    </mat-step>

    <mat-step
      label="Team members"
      [completed]="false"
    >

      <common-mojo-team
        class="team-members d-block px-2 job-form-step-container"
        [accessLevelOptions]="accessLevelOptions"
        templateAppearance="fill"
        autocompletePlaceholder="Team members"
        inputsThemeColor="accent"
        data-cy="job-form-team-members"
        [displayChipsBelow]="true"
        [currentUserId]="(user$ | async)?.id"
        [enableCurrentUserRemove]="true"
        [shares]="shares"
        [showAvatars]="true"
        [sortOrder]="teamRolesSortOrder"
        (addShare)="onAddShare($event)"
        (accessLevelChanged)="onUserAccessChange($event)"
        (deleteShare)="onShareDelete($event)"
        [disabledOptionWhenSelected]="true"
      ></common-mojo-team>

      <div
        class="text-center buttons"
        *ngIf="user$ | async"
      >
        <button
          mat-raised-button
          color="primary"
          matStepperNext
          class="lg"
          (click)="submit()"
          data-cy="job-form-team-members-save-button"
        >
          SAVE
        </button>
      </div>
    </mat-step>
  </ng-container>
</mat-horizontal-stepper>
